/* The size picker.

   WHY THIS EXISTS: a native <select> popup is drawn by the operating system. Its width,
   height, type size and position are outside CSS control — on desktop it rendered oversized
   and detached from the field, and a 40-size rug produced a list that covered the page.

   So on POINTER devices the popup is replaced with a panel this theme owns: anchored to the
   field, exactly the field's width, height capped with its own scroll.

   TOUCH DEVICES KEEP THE NATIVE PICKER on purpose — the iOS and Android wheels are better
   than anything a web page can draw, and they never sit in the wrong place.

   The real <select> remains the source of truth. Every choice writes back to it and fires a
   'change' event, so price, variant id, availability, delivery estimate and the sticky buy
   bar keep working through their existing listeners — none of them know this file exists.
   Without JavaScript the native control is untouched and fully usable. */
(function () {
  var sel = document.querySelector('[data-variant-select]');
  if (!sel || !sel.options.length) return;
  // Sort the native control first so mobile and desktop receive the same order.
  var engine = window.IndiaLivingSizes;
  var selected = sel.value;
  if (engine) {
    var options = [].slice.call(sel.options).map(function (opt) {
      return { option: opt, size: engine.parse(opt.getAttribute('data-title') || opt.textContent) };
    }).filter(function (entry) { return entry.size.group !== 'Custom'; });
    options.sort(function (a, b) { return engine.compare(a.size, b.size); });
    while (sel.firstChild) sel.removeChild(sel.firstChild);
    engine.groups.forEach(function (group) {
      var members = options.filter(function (entry) { return entry.size.group === group; });
      if (!members.length) return;
      var optgroup = document.createElement('optgroup'); optgroup.label = group === 'Runner' ? 'RUNNERS' : group.toUpperCase();
      members.forEach(function (entry) {
        var clean = engine.label(entry.size);
        if (clean) entry.option.textContent = clean + (entry.option.getAttribute('data-ready') === 'true' ? ' — ready to ship' : '');
        optgroup.appendChild(entry.option);
      });
      sel.appendChild(optgroup);
    });
    if (options.some(function(entry){return entry.option.value === selected;})) sel.value = selected;
  }
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var wrap = document.createElement('div');
  wrap.className = 'sizeui sizeui--js';
  sel.parentNode.insertBefore(wrap, sel);
  wrap.appendChild(sel);

  var field = document.createElement('button');
  field.type = 'button';
  field.className = 'sizeui__field';
  field.setAttribute('aria-haspopup', 'listbox');
  field.setAttribute('aria-expanded', 'false');
  field.innerHTML = '<span data-sizeui-label></span><span class="sizeui__caret" aria-hidden="true">▾</span>';
  wrap.appendChild(field);

  var panel = document.createElement('div');
  panel.className = 'sizeui__panel';
  panel.setAttribute('role', 'listbox');
  panel.hidden = true;
  wrap.appendChild(panel);

  var label = field.querySelector('[data-sizeui-label]');
  var rows = [];

  // Mirror the select's structure, optgroup headers included.
  [].forEach.call(sel.children, function (node) {
    if (node.tagName === 'OPTGROUP') {
      var h = document.createElement('span');
      h.className = 'sizeui__group';
      h.textContent = node.label;
      panel.appendChild(h);
      [].forEach.call(node.children, addRow);
    } else if (node.tagName === 'OPTION') {
      addRow(node);
    }
  });

  function addRow(opt) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sizeui__opt';
    b.setAttribute('role', 'option');
    b.setAttribute('data-value', opt.value);
    b.textContent = opt.textContent;
    if (opt.disabled) b.disabled = true;
    panel.appendChild(b);
    rows.push(b);
  }

  function syncLabel() {
    var o = sel.options[sel.selectedIndex];
    label.textContent = o ? o.textContent : '';
    rows.forEach(function (r) {
      r.setAttribute('aria-selected', o && r.getAttribute('data-value') === o.value ? 'true' : 'false');
    });
  }

  var active = -1;
  function mark(i) {
    rows.forEach(function (r) { r.classList.remove('is-active'); });
    if (i >= 0 && rows[i]) {
      rows[i].classList.add('is-active');
      rows[i].scrollIntoView({ block: 'nearest' });
    }
    active = i;
  }

  function open() {
    panel.hidden = false;
    field.setAttribute('aria-expanded', 'true');
    // Open upwards when the field sits low in the window, so the list is never half
    // off-screen. Measured each time, because the field's position moves with the page.
    var room = window.innerHeight - field.getBoundingClientRect().bottom;
    panel.classList.toggle('sizeui__panel--up', room < Math.min(panel.scrollHeight, 330) + 16);
    var cur = rows.findIndex(function (r) { return r.getAttribute('aria-selected') === 'true'; });
    mark(cur > -1 ? cur : 0);
  }
  function close() {
    panel.hidden = true;
    field.setAttribute('aria-expanded', 'false');
    mark(-1);
  }
  function isOpen() { return !panel.hidden; }

  function choose(value) {
    sel.value = value;
    sel.dispatchEvent(new Event('change', { bubbles: true }));  // everything else listens here
    syncLabel();
    close();
    field.focus();
  }

  field.addEventListener('click', function () { isOpen() ? close() : open(); });

  panel.addEventListener('click', function (ev) {
    var r = ev.target.closest('[data-value]');
    if (r && !r.disabled) choose(r.getAttribute('data-value'));
  });

  field.addEventListener('keydown', function (ev) {
    if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp' || ev.key === 'Enter' || ev.key === ' ') {
      ev.preventDefault();
      if (!isOpen()) { open(); return; }
      if (ev.key === 'Enter' || ev.key === ' ') { if (rows[active]) choose(rows[active].getAttribute('data-value')); return; }
      var next = ev.key === 'ArrowDown' ? active + 1 : active - 1;
      if (next < 0) next = rows.length - 1;
      if (next >= rows.length) next = 0;
      mark(next);
    } else if (ev.key === 'Escape' && isOpen()) {
      ev.preventDefault();
      close();
    } else if (ev.key === 'Home' && isOpen()) { ev.preventDefault(); mark(0); }
    else if (ev.key === 'End' && isOpen()) { ev.preventDefault(); mark(rows.length - 1); }
  });

  document.addEventListener('click', function (ev) {
    if (!ev.target.closest('.sizeui') && isOpen()) close();
  });

  // Anything else that changes the variant (a colourway link, a deep link) keeps the field honest.
  sel.addEventListener('change', syncLabel);
  syncLabel();
})();
